import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import PopModal from '../../../Constant/Custom/Models/PopModal';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import { DISTRICTS } from '../../../Constant/Static/config';
import Loader from '../../../Constant/Custom/Loader';

function Address({ handleNext, handlePrevious }) {

    const { auth } = useContext(AuthContext);

    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
    const [onConfirm, setOnConfirm] = useState(() => () => { });

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const storedUser = auth.user;
    // console.log(storedUser);

    const [formData, setFormData] = useState({
        appNo: storedUser?.appno || '',
        appName: storedUser?.userName || '',
        email: storedUser?.email || '',
        phone: storedUser?.mobile || '',
        houseAddress: {
            address: '',
            street: '',
            village: '',
            taluk: '',
            district: '',
            pin: '',
        },
        permanentAddress: {
            address: '',
            street: '',
            village: '',
            taluk: '',
            district: '',
            pin: ''
        }
    });

    const setDefaultForm = () => {
        setFormData({
            appNo: storedUser?.appno || '',
            appName: storedUser?.userName || '',
            email: storedUser?.email || '',
            phone: storedUser?.mobile || '',
            houseAddress: {
                address: '',
                street: '',
                village: '',
                taluk: '',
                district: '',
                pin: '',
            },
            permanentAddress: {
                address: '',
                street: '',
                village: '',
                taluk: '',
                district: '',
                pin: ''
            }
        })
    }

    const [isSameAddress, setIsSameAddress] = useState(false);

    const handleCheckboxChange = (event) => {
        const { checked } = event.target;
        setIsSameAddress(checked);
        handleAddressChange(checked);
    };

    const handleAddressChange = (isSame) => {
        if (isSame) {
            setFormData(prevState => ({
                ...prevState,
                permanentAddress: { ...prevState.houseAddress }
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                permanentAddress: {
                    address: '',
                    street: '',
                    village: '',
                    taluk: '',
                    district: '',
                    pin: ''
                }
            }));
        }
    };

    const [csrfToken, setCsrfToken] = useState('');
    const [errors, setErrors] = useState({});

    const validateField = (name, value) => {
        let errorMessage = '';

        if (name.includes('address') && value.trim().length < 1) {
            errorMessage = 'Address cannot be empty';
        }
        if (name.includes('street') && value.trim().length < 1) {
            errorMessage = 'Street cannot be empty';
        }
        if (name.includes('village') && value.trim().length < 1) {
            errorMessage = 'Village cannot be empty';
        }
        if (name.includes('taluk') && value.trim().length < 1) {
            errorMessage = 'Taluk cannot be empty';
        }
        if (name.includes('taluk') && !/^[A-Za-z\s\-()]+$/.test(value)) {
            errorMessage = 'Invalid Taluk name.';
       }
        if (name.includes('district') && value.trim().length < 1) {
            errorMessage = 'District cannot be empty';
        }
        if (name.includes('pin') && !/^\d{6}$/.test(value)) {
            errorMessage = 'Invalid Pin.';
        }

        return errorMessage;
    };

    const setNestedValue = (object, path, value) => {
        const keys = path.split('.');
        let tempObj = object;
        keys.slice(0, -1).forEach((key) => {
            if (!tempObj[key]) tempObj[key] = {};
            tempObj = tempObj[key];
        });
        tempObj[keys[keys.length - 1]] = value;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        let error = validateField(name, value);

        setFormData((prev) => {
            const updatedFormData = { ...prev };
            if (name.includes('.')) {
                setNestedValue(updatedFormData, name, value);
            } else {
                updatedFormData[name] = value;
            }
            return updatedFormData;
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (name.includes('.')) {
                setNestedValue(updatedErrors, name, error);
            } else {
                updatedErrors[name] = error;
            }
            return updatedErrors;
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            const value = formData[key];
            if (typeof value === 'object') {
                // For nested fields (e.g., address)
                Object.keys(value).forEach((nestedKey) => {
                    const nestedValue = value[nestedKey];
                    const error = validateField(`${key}.${nestedKey}`, nestedValue);
                    if (error) {
                        isValid = false;
                        setNestedValue(newErrors, `${key}.${nestedKey}`, error);
                    }
                });
            } else {
                const error = validateField(key, value);
                if (error) {
                    isValid = false;
                    newErrors[key] = error;
                }
            }
        });

        setErrors(newErrors);
        return isValid;
    };

    const handleAddressDetailSubmit = async () => {

        // console.log(errors);

        if (!validateForm()) {
            setModalType({
                icon: 'warning',
                title: 'Warning',
                text: 'Please Fill All the Required Details',
            });
            openModal();
            setOnConfirm(() => closeModal);
            // console.log('Form is not valid');
            return;
        } else {
            try {
                setLoading(true);
                const response = await axios.post(`${serverUrl}/api/user/addressInfo`, { formData }, {
                    headers: {
                        'CSRF-Token': csrfToken
                    },
                    withCredentials: true
                });
                if (response.status === 200) {
                    setModalType({
                        icon: 'success',
                        title: 'Success',
                        text: 'Address Informations are saved.',
                    });
                    openModal();
                    setOnConfirm(() => handleNext);
                } else {
                    // console.log(response);
                }
            } catch (err) {
                console.error('Failed to store data', err);
            }
            finally {
                setLoading(false);
            }
        }
    };

    // First useEffect: Fetch CSRF token
    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);  // Empty dependency array: runs only on mount

    // Second useEffect: Fetch user data after CSRF token is fetched
    useEffect(() => {
        const fetchUserData = async () => {
            localStorage.setItem('currentSection', 2);
            if (csrfToken) {
                try {
                    setLoading(true);
                    const userDataFromLocalStorage = auth.user;
                    if (userDataFromLocalStorage) {
                        const response = await axios.post(
                            `${serverUrl}/api/user/loadAddressInfo`,
                            {
                                appno: userDataFromLocalStorage.appno,
                                userName: userDataFromLocalStorage.userName,
                                email: userDataFromLocalStorage.email,
                                mobile: userDataFromLocalStorage.mobile
                            },
                            {
                                headers: {
                                    'CSRF-Token': csrfToken  // Use CSRF token
                                },
                                withCredentials: true
                            }
                        );
                        if (response.data.houseAddress === "") {
                            setDefaultForm();
                        } else {
                            setFormData(response.data);  // Set user data
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);  // Dependency on csrfToken: runs when csrfToken changes


    if (loading) {
        return <Loader />;
    }

    return (
        <section>
            <div className='section-head-container'>
                <h2 className='section-title'>Address Information</h2>
                {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
            </div>
            <p style={{ paddingLeft: '10px' }}>Address For Communication</p>
            <div className='form-group'>
                <div>
                    <div className='form-item'>
                        <label>
                            Door Number
                        </label>
                        <span>(கதவு எண்)</span>
                        <input type="text" name="houseAddress.address" placeholder='Enter House Address' value={formData.houseAddress?.address || ''} onChange={handleChange} required />
                        {errors.houseAddress?.address && <span className='form-item-incorrect'>{errors.houseAddress.address}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            Street
                        </label>
                        <span>(தெரு)</span>
                        <input type="text" name="houseAddress.street" placeholder='Enter Street' value={formData.houseAddress?.street || ''} onChange={handleChange} required />
                        {errors.houseAddress?.street && <span className='form-item-incorrect'>{errors.houseAddress?.street}</span>}
                    </div>

                    <div className='form-item'>
                        <label>
                            Village/ City:
                        </label>
                        <span>(கிராமம்/ நகரத்தின் பெயர்)</span>
                        <input type="text" name="houseAddress.village" placeholder='Enter Village/City' value={formData.houseAddress?.village || ''} onChange={handleChange} required />
                        {errors.houseAddress?.village && <span className='form-item-incorrect'>{errors.houseAddress?.village}</span>}
                    </div>
                </div>
                <div>
                    <div className='form-item'>
                        <label>
                            Taluk
                        </label>
                        <span>(வட்டம்)</span>
                        <input type="text" name="houseAddress.taluk" placeholder='Enter Taluk' value={formData.houseAddress?.taluk || ''} onChange={handleChange} required />
                        {errors.houseAddress?.taluk && <span className='form-item-incorrect'>{errors.houseAddress?.taluk}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            District
                        </label>
                        <span>(மாவட்டம்)</span>
                        <select name="houseAddress.district" value={formData.houseAddress?.district || ''} onChange={handleChange} required>
                            <option value=""> --- Select District --- </option>
                            {DISTRICTS.map((item, index) => (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                        {/* <input type="text" name="houseAddress.district" placeholder='Enter District' value={formData.houseAddress?.district || ''} onChange={handleChange} required /> */}
                        {errors.houseAddress?.district && <span className='form-item-incorrect'>{errors.houseAddress?.district}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            Pincode
                        </label>
                        <span>(அஞ்சல் எண்)</span>
                        <input type="text" name="houseAddress.pin" placeholder='Enter Pincode' value={formData.houseAddress?.pin || ''} onChange={handleChange} required />
                        {errors.houseAddress?.pin && <span className='form-item-incorrect'>{errors.houseAddress?.pin}</span>}
                    </div>
                </div>
            </div>
            <hr style={{ height: "1px", backgroundColor: "black" }}></hr>
            <p style={{ paddingLeft: '10px' }}>Permanent Address</p>
            <div style={{ paddingLeft: '10px' }}>
                <input
                    type="checkbox"
                    name="sameAddress"
                    value={1}
                    checked={isSameAddress}
                    onChange={handleCheckboxChange}
                />
                <label>Same as Address For Communication</label>
            </div>
            <div className='form-group'>
                <div>
                    <div className='form-item'>
                        <label>
                            Door Number
                        </label>
                        <span>(கதவு எண்)</span>

                        <input type="text" name="permanentAddress.address" placeholder='Enter House Address' value={formData.permanentAddress?.address || ''} onChange={handleChange} required />
                        {errors.permanentAddress?.address && <span className='form-item-incorrect'>{errors.permanentAddress?.address}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            Street
                        </label>
                        <span>(தெரு)</span>

                        <input type="text" name="permanentAddress.street" placeholder='Enter Street' value={formData.permanentAddress?.street || ''} onChange={handleChange} required />
                        {errors.permanentAddress?.street && <span className='form-item-incorrect'>{errors.permanentAddress?.street}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            Village/ City:
                        </label>
                        <span>(கிராமம்/ நகரத்தின் பெயர்)</span>

                        <input type="text" name="permanentAddress.village" placeholder='Enter Village/City' value={formData.permanentAddress?.village || ''} onChange={handleChange} required />
                        {errors.permanentAddress?.village && <span className='form-item-incorrect'>{errors.permanentAddress?.village}</span>}
                    </div>
                </div>
                <div>
                    <div className='form-item'>
                        <label>
                            Taluk
                        </label>
                        <span>(வட்டம்)</span>

                        <input type="text" name="permanentAddress.taluk" placeholder='Enter Taluk' value={formData.permanentAddress?.taluk || ''} onChange={handleChange} required />
                        {errors.permanentAddress?.taluk && <span className='form-item-incorrect'>{errors.permanentAddress?.taluk}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            District
                        </label>
                        <span>(மாவட்டம்)</span>

                        <select name="permanentAddress.district" value={formData.permanentAddress?.district || ''} onChange={handleChange} required>
                            <option value=""> --- Select District --- </option>
                            {DISTRICTS.map((item, index) => (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                        {/* <input type="text" name="permanentAddress.district" placeholder='Enter District' value={formData.permanentAddress?.district || ''} onChange={handleChange} required /> */}
                        {errors.permanentAddress?.district && <span className='form-item-incorrect'>{errors.permanentAddress?.district}</span>}
                    </div>
                    <div className='form-item'>
                        <label>
                            Pincode
                        </label>
                        <span>(அஞ்சல் எண்)</span>

                        <input type="text" name="permanentAddress.pin" placeholder='Enter Pincode' value={formData.permanentAddress?.pin || ''} onChange={handleChange} required />
                        {errors.permanentAddress?.pin && <span className='form-item-incorrect'>{errors.permanentAddress?.pin}</span>}
                    </div>
                </div>
            </div>
            <br />
            <div className='next-button'>
                <button className='log-btn button-secondary' onClick={handlePrevious}>Previous</button>
                <input type='submit' className='button button-primary' onClick={handleAddressDetailSubmit} value='Save & Next' />
            </div>
            <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PopModal
                    isOpen={isModalOpen}
                    type={modalType}
                    confirmButtonText="OK"
                    onConfirm={onConfirm}
                />
            </div>
        </section>
    )
}

export default Address;